export default "__VITE_ASSET__Dsw5k_hJ__"